"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./Address.module.scss";
import { containsEmojis, formatAddress, parseEmojis } from "@/helpers/Helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Link from "next/link";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
export function WalletAddress(props) {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getRandomObjectId();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const uniqueId = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getRandomObjectId();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const uniqueIdEns = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getRandomObjectId();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const uniqueIdWallet = t2;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);
  let t3;
  if ($[3] !== props.display || $[4] !== props.wallet) {
    t3 = function resolveDisplay() {
      if (props.display) {
        if (containsEmojis(props.display)) {
          return parseEmojis(props.display);
        }
        return formatAddress(props.display);
      }
      return formatAddress(props.wallet);
    };
    $[3] = props.display;
    $[4] = props.wallet;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const resolveDisplay = t3;
  let t4;
  if ($[6] !== props.displayEns || $[7] !== resolveDisplay) {
    t4 = function resolveAddress() {
      if (props.displayEns) {
        if (containsEmojis(props.displayEns)) {
          return parseEmojis(props.displayEns);
        }
        return formatAddress(props.displayEns);
      }
      return resolveDisplay();
    };
    $[6] = props.displayEns;
    $[7] = resolveDisplay;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const resolveAddress = t4;
  let t5;
  if ($[9] !== props.display || $[10] !== props.displayEns || $[11] !== props.setLinkQueryAddress || $[12] !== props.wallet) {
    t5 = function getLink() {
      let path;
      if (props.display && !containsEmojis(props.display)) {
        path = props.display;
      } else {
        path = props.wallet;
      }
      if (props.setLinkQueryAddress) {
        return `/${encodeURIComponent(path)}?address=${encodeURIComponent(props.displayEns ?? props.wallet)}`;
      }
      return `/${encodeURIComponent(path)}`;
    };
    $[9] = props.display;
    $[10] = props.displayEns;
    $[11] = props.setLinkQueryAddress;
    $[12] = props.wallet;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const getLink = t5;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = function copy(text) {
      navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    };
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const copy = t6;
  const [walletEns] = useState(props.display?.endsWith(".eth") ? props.display : props.displayEns?.endsWith(".eth") ? props.displayEns : null);
  let t7;
  if ($[15] !== getLink || $[16] !== props.disableLink || $[17] !== props.hideCopy || $[18] !== resolveDisplay) {
    t7 = (props.hideCopy || !navigator.clipboard) && (props.disableLink ? <span className={styles.address}>{resolveDisplay()}</span> : <Link href={getLink()} className={styles.address}>{resolveDisplay()}</Link>);
    $[15] = getLink;
    $[16] = props.disableLink;
    $[17] = props.hideCopy;
    $[18] = resolveDisplay;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== getLink || $[21] !== isCopied || $[22] !== isDropdownOpen || $[23] !== props.disableLink || $[24] !== props.display || $[25] !== props.displayEns || $[26] !== props.hideCopy || $[27] !== props.isUserPage || $[28] !== props.wallet || $[29] !== resolveAddress || $[30] !== resolveDisplay || $[31] !== walletEns) {
    t8 = !props.hideCopy && navigator.clipboard && <>{!props.isUserPage && <span className={`${styles.address} ${props.isUserPage ? styles.addressUserPage : ""}`}>{props.disableLink ? <span className={styles.address}>{resolveDisplay()}</span> : <Link href={getLink()} className={styles.address}>{resolveDisplay()}</Link>}</span>}{walletEns ? <Dropdown ref={dropdownRef} className={`${styles.copyDropdown}`} autoClose="outside" data-tooltip-id={uniqueId} onToggle={nextShow => {
        setIsDropdownOpen(nextShow);
      }}><Dropdown.Toggle name="copy-toggle" aria-label="copy-toggle">{props.isUserPage && props.display && <span className={`${styles.address} ${props.isUserPage ? styles.addressUserPage : ""}`}>{formatAddress(props.display)}</span>}<FontAwesomeIcon icon={faCopy} name="copy-btn" aria-label="copy-btn" className={`${styles.copy}`} /></Dropdown.Toggle><Dropdown.Menu>{props.display && <Dropdown.Item data-tooltip-id={uniqueIdEns} aria-label="copy-ens-btn" onClick={() => copy(props.displayEns ?? props.display)} dangerouslySetInnerHTML={{
            __html: resolveAddress()
          }} />}<Dropdown.Item data-tooltip-id={uniqueIdWallet} className={styles.copyDropdownItem} aria-label="copy-address-btn" onClick={() => copy(props.wallet)}>{formatAddress(props.wallet as string)}</Dropdown.Item></Dropdown.Menu></Dropdown> : <Dropdown ref={dropdownRef} className={`${styles.copyDropdown}`} autoClose="outside" data-tooltip-id={uniqueId} onToggle={nextShow_0 => {
        setIsDropdownOpen(nextShow_0);
      }}><Dropdown.Toggle name="copy-toggle" aria-label="copy-toggle" onClick={() => copy(props.wallet)}>{props.isUserPage && <span className={`${styles.address} ${props.isUserPage ? styles.addressUserPage : ""}`} dangerouslySetInnerHTML={{
            __html: resolveAddress()
          }} />}<FontAwesomeIcon icon={faCopy} name="copy-btn" aria-label="copy-btn" className={`${styles.copy}`} /></Dropdown.Toggle></Dropdown>}{!isDropdownOpen ? <Tooltip id={uniqueId} delayShow={150} place="right" opacity={1} variant="light" className="tw-leading-tight">{isCopied ? "Copied" : "Copy"}</Tooltip> : <><Tooltip id={uniqueIdEns} delayShow={150} place="right" opacity={1} variant="light" className="tw-leading-tight">{isCopied ? "Copied" : "Copy"}</Tooltip><Tooltip id={uniqueIdWallet} delayShow={150} place="right" opacity={1} variant="light" className="tw-leading-tight">{isCopied ? "Copied" : "Copy"}</Tooltip></>}</>;
    $[20] = getLink;
    $[21] = isCopied;
    $[22] = isDropdownOpen;
    $[23] = props.disableLink;
    $[24] = props.display;
    $[25] = props.displayEns;
    $[26] = props.hideCopy;
    $[27] = props.isUserPage;
    $[28] = props.wallet;
    $[29] = resolveAddress;
    $[30] = resolveDisplay;
    $[31] = walletEns;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== t7 || $[34] !== t8) {
    t9 = <span>{t7}{t8}</span>;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
}